import { useSelector } from 'react-redux';
import { selectEmail, selectIsAuth } from '../auth/auth.selector';
import { validatemap_form_email } from '../../exports/Validations';

/**
 * Checks if the logged-in user's email is valid
 * @returns {boolean} Returns true if user is logged in and has a valid email, false otherwise
 */
export const useUserEmailValid = () => {
  // Use selector hooks to get authentication state and email
  const isAuthenticated = useSelector(selectIsAuth);
  const userEmail = useSelector(selectEmail);

  // If user is not authenticated or email is not available, return false
  if (!isAuthenticated || !userEmail) {
    return false;
  }

  // Validate the email using the existing validation function
  return validatemap_form_email(userEmail);
};

export const isUserEmailValid = (isAuthenticated, userEmail) => {
  if (!isAuthenticated || !userEmail) {
    return false;
  }

  return validatemap_form_email(userEmail);
};

/**
 * Checks if the email is in the list of allowed emails
 * @param {string} email - The email to check
 * @returns {boolean} Returns true if the email is in the allowed list, false otherwise
 */
export const isAprovalAllowedEmail = (email) => {
  const allowedEmails = [
    'arpit@wtfup.me',
    'vn@wtfgyms.com',
    'sharma.wtfwork@gmail.com',
    'admiin@wtfgyms.com',
    'naresh.kukreti@wtfup.me',
    'mousumi.malik@wtfup.me',
    'chetan.sharma@wtfgyms.com',
    'deepti.chauhan@wtfgyms.com',
    'jitendra.gautam@wtfpoweredgyms.com',
    // "vishal@wtfup.me",
    'naresh.kukreti@wtfgyms.com',
    'paras.gupta@wtfgyms.com',
  ];

  return allowedEmails.includes(email);
};

export const isBroadcastCreateAllowedEmail = (email) => {
  const allowedEmails = [
    'vn@wtfgyms.com',
    'arpit@wtfup.me',
    'sharma.wtfwork@gmail.com',
    'naresh.kukreti@wtfup.me',
    'mousumi.malik@wtfup.me',
    'digitalmarketing@wtfgyms.com',
    'nigamamrita2000@gmail.com',
    'paras.gupta@wtfgyms.com',
  ];

  return allowedEmails.includes(email);
};

export const isMemberDeleteEmail = (email) => {
  const allowedEmails = [
    'vn@wtfgyms.com',
    'arpit@wtfup.me',
    'anita@wtfup.me',
    'ankit.kumar@wtfgyms.com',
    'jitendra.gautam@wtfpoweredgyms.com',
    'naresh.kukreti@wtfup.me',
    'naresh.kukreti@wtfgyms.com',
    'mousumi.malik@wtfup.me',
  ];

  return allowedEmails.includes(email);
};

export const IS_CRUD_ACCESS_BY_EMAIL = (email) => {
  const allowedEmails = ['vn@wtfgyms.com', 'naresh.kukreti@wtfup.me', 'mousumi.malik@wtfup.me'];

  return allowedEmails.includes(email);
};

export const IS_USER_ADD_BY_EMAIL = (email) => {
  const allowedEmails = [
    'vn@wtfgyms.com',
    'ankit.kumar@wtfgyms.com',
    'aitools@wtfgyms.com',
    'naresh.kukreti@wtfup.me',
    'mousumi.malik@wtfup.me',
  ];

  return allowedEmails.includes(email);
};
